const getExchangeRate = state => state.exchangeRate;
const getCountries = state => state.countries;
const getSelectedPersonType = state => state.selectedPersonType;
const getSelectedPlan = state => state.selectedPlan;
const getStudentsNumber = state => state.studentsNumber;
const getBillingDetails = state => state.billing;
const getBraintreeResponse = state => state.braintreeResponse;
const getBraintreeClientTokenResponse = state => state.braintreeClientTokenResponse;

export default {
  getExchangeRate,
  getCountries,
  getSelectedPersonType,
  getSelectedPlan,
  getStudentsNumber,
  getBillingDetails,
  getBraintreeResponse,
  getBraintreeClientTokenResponse
};



// WEBPACK FOOTER //
// ./src/store/modules/purchase/getters.js